import { useMemo } from "react"
import _ from "lodash"

import { useSponsoredContent } from "./useSponsoredContent"
import { SponsoredContentFeature, useGetScreensavers } from "venue-react"

interface ISponsorContentConfig {
  disable?: boolean
  limit?: number
  frequency?: number
  autoplay?: boolean
  interval?: number
}

interface IUseSponsoredScreensaverResult {
  screensavers: SponsoredContentFeature[]
  screensaverConfig: ISponsorContentConfig
}
export const useSponsoredScreensaver = (): IUseSponsoredScreensaverResult => {
  const { screensaver } = useSponsoredContent()

  const screensaverConfig = useMemo(
    () => _.get(screensaver, "config"),
    [screensaver]
  )

  const { data: screensavers = [] } = useGetScreensavers()

  return {
    screensavers,
    screensaverConfig,
  }
}
